import { jsx as m } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import a from "./styles.module.less.js";
const c = f((t, r) => {
  var e, o;
  const { value: s, disabled: u, onChange: n, error: l } = t;
  return /* @__PURE__ */ m(
    "input",
    {
      ref: r,
      ...t.props,
      className: `${a.textInput} ${((e = t.props) == null ? void 0 : e.className) || ""} ${l ? a.error : ""}`,
      type: "text",
      value: s || "",
      onChange: (p) => n(p.target.value),
      autoFocus: typeof ((o = t.props) == null ? void 0 : o.autoFocus) == "boolean" ? t.props.autoFocus : !1,
      disabled: u
    }
  );
});
c.displayName = "TextInput";
export {
  c as TextInput,
  c as default
};
